import {
  CreateMemberRoundInput,
  CreateGuestRoundInput,
  NewGuestRoundInput,
} from "../../hooks/useCreateNewGolfBooking/__generated__/useCreateNewGolfBookingMutation.graphql";
import { BookingWizard } from "../../types";
import { ClientType } from "./types";

export const processPrivateBookingRounds = <
  T extends CreateMemberRoundInput | CreateGuestRoundInput | NewGuestRoundInput
>(
  rounds: BookingWizard.GolfRound[] | undefined,
  clientTypes: ClientType[],
  golfProperties: {
    courseLayout?: BookingWizard.CourseLayout;
    transportationTypeId: string | null;
  },
  additionalProps?: (round: BookingWizard.GolfRound) => Partial<T>
): T[] => {
  return (
    rounds
      ?.filter((round) => clientTypes.includes(round.player.clientType))
      .map(
        (round) =>
          ({
            ...(round.id ? { id: round.id } : {}),
            index: round.index,
            nonPlayingHost:
              round.player.clientType === "member"
                ? round.player.nonPlayingHost
                : undefined,
            playerId:
              round.player.clientType === "newGuest" ||
              round.player.clientType === "memberHold" ||
              round.player.clientType === "unknownGuest"
                ? undefined
                : round.player.id,
            courseLayoutId: golfProperties.courseLayout?.id,
            transportationTypeId:
              round.transportationType?.id ??
              golfProperties.transportationTypeId,
            ...(additionalProps ? additionalProps(round) : {}),
          } as T)
      ) ?? []
  );
};
